import { content } from './content/index.js';
import { mechanicHelpByIds } from './authoring/ui/mechanics.js';
const ENGINE_MECHANICS = Object.freeze({
    RUSH: 'rush',
    CANNOT_ATTACK: 'cannot_attack',
    CANNOT_COOL: 'cannot_cool',
});
/** Semantic timing → mechanic help (D53+); UI получает timing из typed abilityMeta, не из текста. */
const TIMING_MECHANICS = Object.freeze({
    appear: 'appear',
    ongoing: 'ongoing',
    death: 'death',
});
/** Самоочевидные термины остаются typed metadata, но не требуют UI-справки. */
const MECHANICS_WITHOUT_HELP = new Set([
    'appear',
    'ongoing',
    'death',
    'assembly',
    'scrap',
    'cannot_attack',
    'dodge',
    'devour',
]);
export function getCardUi(cardId) {
    return content.ui.get(cardId);
}
/** Explicit card metadata plus the small, typed engine-keyword bridge. */
export function getCardMechanicHelp(cardId, engineKeywords = []) {
    const ids = new Set();
    for (const keyword of engineKeywords) {
        const id = ENGINE_MECHANICS[keyword];
        if (id !== undefined)
            ids.add(id);
    }
    // Timing (Появление/Постоянно/Гибель) выводится из typed abilityMeta, а не из
    // локализованного описания — авторам не нужно вручную перечислять его в mechanics.
    for (const meta of content.cards.get(cardId)?.abilityMeta ?? []) {
        const id = TIMING_MECHANICS[meta.timing];
        if (id !== undefined)
            ids.add(id);
    }
    for (const id of getCardUi(cardId)?.mechanics ?? [])
        ids.add(id);
    return mechanicHelpByIds([...ids].filter((id) => !MECHANICS_WITHOUT_HELP.has(id)));
}
export function getCardPlanningStepLabel(cardId, stepId) {
    return getCardUi(cardId)?.planning?.steps?.[stepId];
}
export function getCardModeLabel(cardId, modeId) {
    return getCardUi(cardId)?.planning?.modes?.[modeId];
}
export function getCardPlaybackLabel(cardId, eventType) {
    return getCardUi(cardId)?.playback?.[eventType];
}
//# sourceMappingURL=ui.js.map